module.exports = __webpack_public_path__ + "img/RBS_event_02.ac6a90c4.png";